import { DroppanelStyle } from '../../../../elements/components/droppanel/entities/droppanel-style.entity';
import { FormInputWithDroppanelVariant } from '../../../../form-controls/entities/form-input-with-droppanel-variant.entity';
import { FilterType } from '../../base/entities/filter-type';
import { Filter } from '../../entities/filter.class';

export class DateFilter extends Filter {
    constructor(field: string) {
        super({ field, filterType: FilterType.Date });
    }

    variant: FormInputWithDroppanelVariant = FormInputWithDroppanelVariant.Default;
    droppanelStyle: DroppanelStyle = DroppanelStyle.Default;
}
